import { render } from "./backHomeBannerComponent.vue?vue&type=template&id=e32b86ee"
import script from "./backHomeBannerComponent.vue?vue&type=script&lang=js"
export * from "./backHomeBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__